import { cookiesStorage } from '@/library/storage';
import { authConstants } from '@/utils/constants';

import {
  HeaderProductsJson,
  HeaderProductsPostLoginJson,
} from '../components/Header/HeaderData';

export const useHeaderProducts = () => {
  const userId = cookiesStorage.getCookie(authConstants.OM_AUTH_USER_ID);
  return userId ? HeaderProductsPostLoginJson : HeaderProductsJson;
};
